<template>
	<v-row justify="center">
		<v-dialog v-model="dialog" persistent max-width="900" scrollable>
			<v-card>
				<v-card-title class="headline">
					<span>Detail Pengiriman Retur</span>
					<span class="pl-2 font-weight-bold">{{ detailRD.pdor_code }}</span>
				</v-card-title>
				<v-card-text class="black--text">
					<v-row class="mb-3">
						<v-col cols="6" md="6">
							<div class="text-subtitle-1 font-weight-bold">Detail Warehouse</div>
							<div class="pt-1">{{detailRD.warehouse_name}}</div>
							<div class="pt-1">{{detailRD.warehouse_email}}</div>
							<div class="pt-1">{{detailRD.warehouse_mobilephone}}</div>
							<div class="pt-1">{{addressText(detailRD)}}</div>
						</v-col>
						<v-col cols="6" md="6">
							<div class="text-subtitle-1 font-weight-bold">Status Pengiriman Retur</div>
							<v-col cols="8" class="mt-1 pa-0">
								<div class="cyan darken-2 rounded text-body-2 text-uppercase white--text text-center text-uppercase font-weight-bold pa-2 justify-center">
									<div>{{detailRD.pdor_status | toStatusPDOWH}}</div>
								</div>
							</v-col>
							<div class="text-subtitle-1 mt-2 font-weight-bold">Catatan</div>
							<v-col cols="12" class="mt-1 pa-0">
								{{ detailRD.pdor_note ? detailRD.pdor_note : '-' }}
							</v-col>
						</v-col>
					</v-row>
					<v-list color="grey lighten-3" class="pa-1 mb-3" rounded>
						<v-list-item dense class="px-1 justify-center">
							<div class="font-weight-bold text-uppercase primary--text">detail produk</div>
						</v-list-item>
					</v-list>
					<v-card class="mb-5 elevation-0">
						<v-data-table dense :headers="headers" :items="detailRD.pdor_detail" hide-default-footer>
							<template v-slot:item.pdor_detail_quantity_sent="{ item }">
								<div>{{ item.pdor_detail_quantity_sent | toNumber }}</div>
							</template>
							<template v-slot:item.pdor_detail_quantity_received="{ item }">
								<div>{{ item.pdor_detail_quantity_received | toNumber }}</div>
							</template>
						</v-data-table>
					</v-card>
					<v-list color="grey lighten-3" class="pa-1 mb-3" rounded>
						<v-list-item dense class="px-1 justify-center">
							<div class="font-weight-bold text-uppercase primary--text">Status Pengiriman Retur</div>
						</v-list-item>
					</v-list>
					<v-row class="mb-3" v-if="detailRD.pdor_status_delivered_datetime">
						<v-col cols="4" md="4" class="py-0">
							<div :class="detailRD.pdor_status == 'delivered' ? 'cyan darken-2' : 'grey'" class="rounded caption text-uppercase white--text text-right pa-3">{{'delivered' | toStatusPDOWH}}</div>
						</v-col>
						<v-col cols="8" md="8" class="text-body-2">
							<div>{{detailRD.pdor_status_delivered_datetime | haritanggaljam}}</div>
						</v-col>
					</v-row>
					<v-row class="mb-3" v-if="detailRD.pdor_status_on_delivery_datetime">
						<v-col cols="4" md="4" class="py-0">
							<div :class="detailRD.pdor_status == 'on_delivery' ? 'cyan darken-2' : 'grey'" class="rounded caption text-uppercase white--text text-right pa-3">{{'on_delivery' | toStatusPDOWH}}</div>
						</v-col>
						<v-col cols="8" md="8" class="text-body-2">
							<div>{{detailRD.pdor_status_on_delivery_datetime | haritanggaljam}}</div>
						</v-col>
					</v-row>
					<v-row class="mb-3" v-if="detailRD.pdor_status_created_datetime">
						<v-col cols="4" md="4" class="py-0">
							<div :class="detailRD.pdor_status == 'created' ? 'cyan darken-2' : 'grey'" class="rounded caption text-uppercase white--text text-right pa-3">{{'created' | toStatusPDOWH}}</div>
						</v-col>
						<v-col cols="8" md="8" class="text-body-2">
							<div>{{ detailRD.pdor_status_created_datetime | haritanggaljam}}</div>
						</v-col>
					</v-row>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="grey darken-1" outlined class="text-capitalize" @click="hideDialog">Tutup</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-row>
</template>

<script>
import { mapState } from 'vuex'

export default {
	data () {
		return {
			singleSelect: false,
			selected: [],
			headers: [
			{ text: 'Nama Produk', value: 'supplier_product_name', sortable: false},
			{ text: 'Kode Produk', value: 'supplier_product_code', sortable: false},
			{ text: 'Jumlah Kirim', value: 'pdor_detail_quantity_sent', sortable: false, align: 'center' },
			{ text: 'Jumlah Diterima', value: 'pdor_detail_quantity_received', sortable: false, align: 'center' },
			],
		}
	},
	computed:{
		...mapState('pdoReturSupplier', ['detailRD']),
	},
	props: {
		dialog: Boolean
	},
	methods :{
		hideDialog(){
			this.$emit('hideDialog')
		},
		addressText(value) {
			var data = []
			if (value.warehouse_address)
				data.push(value.warehouse_address)
			if (value.warehouse_subdistrict_name)
				data.push(value.warehouse_subdistrict_name)
			if (value.warehouse_city_name)
				data.push(value.warehouse_city_name)
			if (value.warehouse_province_name)
				data.push(value.warehouse_province_name)
			return data.join(', ')
		}
	}
}
</script>